import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-582348ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-tela-conteudo" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_7 = {
  class: "ss-card ss-card-space",
  style: {"height":"calc(100% - 170px)"}
}
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Filtros", -1))
const _hoisted_11 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-alinhar-centro" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Novo", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-tela-sub-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "DEFINA OS FILTROS ABAIXO")
], -1))
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-13" }
const _hoisted_21 = { class: "ant-row ss-agenda-margin-botoes" }
const _hoisted_22 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limpar", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Aplicar", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-tela-informacoes" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/img/ilustracoes/agenda.png",
    alt: "Gerencie e organize!"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "ss-tela-informacoes-introducao" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Gerencie e organize!"),
    /*#__PURE__*/_createElementVNode("span", null, "Compromissos, tarefas, eventos"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", null, "e tenha uma rotina mais produtiva.")
  ])
], -1))
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-17" }
const _hoisted_32 = {
  class: "ss-card ss-card-space",
  style: {"height":"calc(100% - 170px)"}
}
const _hoisted_33 = { class: "ant-row" }
const _hoisted_34 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_35 = { class: "ant-btn-group" }
const _hoisted_36 = { class: "ant-btn ss-botoes-icones" }
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-9 ss-alinhar-centro" }
const _hoisted_38 = { class: "ss-calendario-titulo" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-alinhar-centro" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Visualizar por:")
], -1))
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-alinhar-centro" }
const _hoisted_41 = { class: "ss-agendamentos" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "ant-badge-status-text" }
const _hoisted_44 = { class: "ss-agendamentos" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "ant-badge-status-text" }
const _hoisted_47 = {
  key: 1,
  class: "ss-calendario-padrao"
}
const _hoisted_48 = {
  class: "ss-calendario-agendamento ss-agendamento-item table-responsive",
  width: "100%"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " ", -1))
const _hoisted_50 = ["title"]
const _hoisted_51 = { class: "ss-agendamentos" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "ant-badge-status-text" }
const _hoisted_54 = {
  key: 2,
  class: "ss-calendario-padrao"
}
const _hoisted_55 = {
  class: "ss-calendario-agendamento ss-agendamento-item table-responsive",
  width: "100%"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " "),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createElementVNode("b", null, "Agendamentos")
      ])
    ])
  ])
], -1))
const _hoisted_57 = ["title"]
const _hoisted_58 = { class: "ss-agendamentos" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "ant-badge-status-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_marcador = _resolveComponent("selecionar-marcador")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_resumo_agendamento = _resolveComponent("resumo-agendamento")!
  const _component_a_calendar = _resolveComponent("a-calendar")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_agendamento_modal = _resolveComponent("agendamento-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: '',
          tituloRecurso: 'Agenda',
          exibirAtalhosTela: false,
          exibirHistoricoTela: false,
          empresasSelecionadas: _ctx.telaBase.empresasSelecionadas
        }, null, 8, ["empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_a_tooltip, { placement: "top" }, {
                      title: _withCtx(() => [
                        _hoisted_10
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.defineExibicaoFiltros && _ctx.defineExibicaoFiltros(...args))),
                          class: "ant-btn ss-botoes-icones"
                        }, [
                          _createVNode(_component_icone, { nome: "filtro" })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Atualiza o calendário com as últimas informações da agenda."
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.atualizaInformacoesDataAtual && _ctx.atualizaInformacoesDataAtual(...args))),
                          class: "ant-btn ss-botoes-icones"
                        }, [
                          _createVNode(_component_icone, { nome: "atualizar" })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.novoAgendamento && _ctx.novoAgendamento(...args))),
                      type: "button",
                      class: "ant-btn ant-btn-primary ant-btn-block ss-btn-acao-destaque"
                    }, _hoisted_14)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createVNode(_component_a_form, { layout: "vertical" }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        _createVNode(_component_a_form_item, {
                          label: "Tipo",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.stateAgenda.codigoTipoAgendamento,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.stateAgenda.codigoTipoAgendamento) = $event)),
                              placeholder: "Selecione um tipo",
                              class: "ss-tamanho-completo",
                              options: _ctx.stateAgenda.listaTipoAgendamento,
                              allowClear: true
                            }, null, 8, ["value", "options"])
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_a_form_item, {
                          label: "Empresas",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_empresa, {
                              varias: true,
                              codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                              "onUpdate:codigosSelecionados": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
                            }, null, 8, ["codigosSelecionados"])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.stateAgenda.acessoVariasEmpresas]
                        ]),
                        _withDirectives(_createVNode(_component_a_form_item, {
                          label: "Usuários",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_usuario, {
                              empresas: _ctx.telaBase.empresasSelecionadas,
                              codigosSelecionados: _ctx.stateAgenda.usuariosSelecionados,
                              "onUpdate:codigosSelecionados": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.stateAgenda.usuariosSelecionados) = $event)),
                              varios: true,
                              placeholder: "Selecione um ou mais usuários"
                            }, null, 8, ["empresas", "codigosSelecionados"])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.verificaVisualizacaoTodosUsuarios()]
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_a_form_item, {
                              label: "Filtrar por",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.stateAgenda.dataFiltro = '')),
                                  value: _ctx.stateAgenda.tipoDataFiltro,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.stateAgenda.tipoDataFiltro) = $event)),
                                  class: "ss-tamanho-completo"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select_option, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Data Inicio")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_select_option, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Data Fim")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_select_option, { value: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Data/Hora Inicio")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_select_option, { value: 4 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Data/Hora Fim")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_a_form_item, {
                              label: " ",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data, {
                                  dataSelecionada: _ctx.stateAgenda.dataFiltro,
                                  "onUpdate:dataSelecionada": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.stateAgenda.dataFiltro) = $event)),
                                  horaMinuto: (_ctx.stateAgenda.tipoDataFiltro === 3 || _ctx.stateAgenda.tipoDataFiltro === 4)
                                }, null, 8, ["dataSelecionada", "horaMinuto"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createVNode(_component_a_form_item, {
                          label: "Pessoa",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_pessoa, {
                              empresas: _ctx.telaBase.empresasSelecionadas,
                              codigosSelecionados: _ctx.stateAgenda.pessoasSelecionadas,
                              "onUpdate:codigosSelecionados": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.stateAgenda.pessoasSelecionadas) = $event)),
                              recursoOrigem: "AGENDAMENTO",
                              varios: true,
                              placeholder: "Selecione uma ou mais pessoas"
                            }, null, 8, ["empresas", "codigosSelecionados"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "Marcadores",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_marcador, {
                              marcadoresSelecionados: _ctx.stateAgenda.marcadores,
                              "onUpdate:marcadoresSelecionados": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.stateAgenda.marcadores) = $event)),
                              codigoUsuario: 8,
                              placeholder: "Digite para definir um marcador"
                            }, null, 8, ["marcadoresSelecionados"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("button", {
                              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.limparFiltros && _ctx.limparFiltros(...args))),
                              type: "button",
                              class: "ant-btn ant-btn-block ant-btn-secondary"
                            }, _hoisted_24)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("button", {
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.buscarAgendamentosFiltros && _ctx.buscarAgendamentosFiltros(...args))),
                              type: "button",
                              class: "ant-btn ant-btn-block ant-btn-primary"
                            }, _hoisted_27)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.stateAgenda.exibirFiltros]
                    ]),
                    (_ctx.stateAgenda.exibirGradeAgendamentos)
                      ? (_openBlock(), _createBlock(_component_a_table, {
                          key: 0,
                          columns: _ctx.stateAgenda.colunasGrade.filter(item => item.visible),
                          "data-source": _ctx.stateAgenda.listaAgendamentos,
                          rowKey: "codigo",
                          pagination: false,
                          scroll: { x: '100%' , y: 400},
                          loading: _ctx.telaBase.carregando,
                          size: "small"
                        }, {
                          bodyCell: _withCtx(({ column, record, text }) => [
                            (column.title === 'Título')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.editarAgendamento(record.codigo))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(text), 1)
                                ], 8, _hoisted_28))
                              : _createCommentVNode("", true),
                            (column.title === 'Data/Hora')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(text)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source", "loading"]))
                      : _createCommentVNode("", true),
                    _hoisted_30
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_a_tooltip, {
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.navegacaoPeriodo(true,false))),
                        placement: "top",
                        title: "Anterior"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_36, [
                            _createVNode(_component_icone, { nome: "navegacao-anterior" })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Próximo"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.navegacaoPeriodo(false,true))),
                            class: "ant-btn ss-botoes-icones"
                          }, [
                            _createVNode(_component_icone, { nome: "navegacao-proximo" })
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.montaTituloApresentacao()), 1)
                  ]),
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_a_radio_group, {
                      onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.navegacaoPeriodo(false,false))),
                      value: _ctx.stateAgenda.formatoVisualizacao,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.stateAgenda.formatoVisualizacao) = $event)),
                      "button-style": "solid"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_button, {
                          value: _ctx.EVisualizacaoAgendamento.Dia
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Dia")
                          ]),
                          _: 1
                        }, 8, ["value"]),
                        _createVNode(_component_a_radio_button, {
                          value: _ctx.EVisualizacaoAgendamento.Semana
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Semana")
                          ]),
                          _: 1
                        }, 8, ["value"]),
                        _createVNode(_component_a_radio_button, {
                          value: _ctx.EVisualizacaoAgendamento.Mes
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Mês")
                          ]),
                          _: 1
                        }, 8, ["value"]),
                        _createVNode(_component_a_radio_button, {
                          value: _ctx.EVisualizacaoAgendamento.Ano
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Ano")
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ])
                ]),
                _createVNode(_component_a_skeleton, {
                  active: "",
                  loading: _ctx.telaBase.carregando,
                  paragraph: { rows: 15 }
                }, {
                  default: _withCtx(() => [
                    ((_ctx.stateAgenda.formatoVisualizacao === _ctx.EVisualizacaoAgendamento.Mes || _ctx.stateAgenda.formatoVisualizacao === _ctx.EVisualizacaoAgendamento.Ano))
                      ? (_openBlock(), _createBlock(_component_a_calendar, {
                          key: 0,
                          class: "ss-calendario",
                          value: _ctx.stateAgenda.dataAtual,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.stateAgenda.dataAtual) = $event)),
                          mode: _ctx.stateAgenda.formatoVisualizacao === _ctx.EVisualizacaoAgendamento.Mes? 'month':'year' 
                        }, {
                          headerRender: _withCtx(() => []),
                          dateCellRender: _withCtx(({ current }) => [
                            _createElementVNode("ul", _hoisted_41, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtrarAgendamentosPorDia(current), (item) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  title: '',
                                  key: item.codigo
                                }, [
                                  _createVNode(_component_resumo_agendamento, {
                                    agendamento: item,
                                    codigoUsuarioAutenticado: _ctx.stateAgenda.codigoUsuarioAutenticado,
                                    apresentarEmpresa: (_ctx.stateAgenda.acessoVariasEmpresas && _ctx.telaBase.empresasSelecionadas.length > 1)
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.editarAgendamento(item.codigo)),
                                        class: "ant-badge ant-badge-status ant-badge-not-a-wrapper"
                                      }, [
                                        _createElementVNode("span", {
                                          style: _normalizeStyle('background-color:' + item.cor),
                                          class: "ant-badge-status-dot"
                                        }, null, 4),
                                        _createElementVNode("span", _hoisted_43, _toDisplayString(item.titulo), 1)
                                      ], 8, _hoisted_42)
                                    ]),
                                    _: 2
                                  }, 1032, ["agendamento", "codigoUsuarioAutenticado", "apresentarEmpresa"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          monthCellRender: _withCtx(({ current }) => [
                            _createElementVNode("ul", _hoisted_44, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtrarAgendamentosPorMes(current), (item) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  title: '',
                                  key: item.codigo
                                }, [
                                  _createVNode(_component_resumo_agendamento, {
                                    agendamento: item,
                                    codigoUsuarioAutenticado: _ctx.stateAgenda.codigoUsuarioAutenticado,
                                    apresentarEmpresa: (_ctx.stateAgenda.acessoVariasEmpresas && _ctx.telaBase.empresasSelecionadas.length > 1)
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.editarAgendamento(item.codigo)),
                                        class: "ant-badge ant-badge-status ant-badge-not-a-wrapper"
                                      }, [
                                        _createElementVNode("span", {
                                          style: _normalizeStyle('background-color:' + item.cor),
                                          class: "ant-badge-status-dot"
                                        }, null, 4),
                                        _createElementVNode("span", _hoisted_46, _toDisplayString(item.titulo), 1)
                                      ], 8, _hoisted_45)
                                    ]),
                                    _: 2
                                  }, 1032, ["agendamento", "codigoUsuarioAutenticado", "apresentarEmpresa"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }, 8, ["value", "mode"]))
                      : ((_ctx.stateAgenda.formatoVisualizacao === _ctx.EVisualizacaoAgendamento.Semana))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _createElementVNode("table", _hoisted_48, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _hoisted_49,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateAgenda.datasSemana, (dia) => {
                                    return (_openBlock(), _createElementBlock("th", { key: dia }, [
                                      _createElementVNode("p", null, [
                                        _createElementVNode("b", null, _toDisplayString(_ctx.UtilitarioData.obterDiaDaSemanaAbreviado(dia)), 1)
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.UtilitarioData.obterDiaMesAbreviado(dia)), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.horarioAgendamentos, (hora) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: hora }, [
                                    _createElementVNode("td", null, _toDisplayString(hora), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateAgenda.datasSemana, (data) => {
                                      return (_openBlock(), _createElementBlock("td", {
                                        key: data,
                                        title: data
                                      }, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("ul", _hoisted_51, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtrarAgendamentosPorDia(data), (item) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                title: '',
                                                key: item.codigo
                                              }, [
                                                (hora === _ctx.UtilitarioData.aplicaFormatoDataHora(item.dataHoraInicio))
                                                  ? (_openBlock(), _createBlock(_component_resumo_agendamento, {
                                                      key: 0,
                                                      agendamento: item,
                                                      codigoUsuarioAutenticado: _ctx.stateAgenda.codigoUsuarioAutenticado,
                                                      apresentarEmpresa: (_ctx.stateAgenda.acessoVariasEmpresas && _ctx.telaBase.empresasSelecionadas.length > 1)
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("a", {
                                                          onClick: ($event: any) => (_ctx.editarAgendamento(item.codigo)),
                                                          class: "ant-badge ant-badge-status ant-badge-not-a-wrapper"
                                                        }, [
                                                          _createElementVNode("span", {
                                                            style: _normalizeStyle('background-color:' + item.cor),
                                                            class: "ant-badge-status-dot"
                                                          }, null, 4),
                                                          _createElementVNode("span", _hoisted_53, _toDisplayString(item.titulo), 1)
                                                        ], 8, _hoisted_52)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["agendamento", "codigoUsuarioAutenticado", "apresentarEmpresa"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ], 8, _hoisted_50))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : ((_ctx.stateAgenda.formatoVisualizacao === _ctx.EVisualizacaoAgendamento.Dia))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                              _createElementVNode("table", _hoisted_55, [
                                _hoisted_56,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.horarioAgendamentos, (hora) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: hora }, [
                                      _createElementVNode("td", null, _toDisplayString(hora), 1),
                                      (_openBlock(), _createElementBlock("td", {
                                        key: _ctx.stateAgenda.dataAtual,
                                        title: _ctx.stateAgenda.dataAtual
                                      }, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("ul", _hoisted_58, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtrarAgendamentosPorDia(_ctx.stateAgenda.dataAtual), (item) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                title: '',
                                                key: item.codigo
                                              }, [
                                                (hora === _ctx.UtilitarioData.aplicaFormatoDataHora(item.dataHoraInicio))
                                                  ? (_openBlock(), _createBlock(_component_resumo_agendamento, {
                                                      key: 0,
                                                      agendamento: item,
                                                      codigoUsuarioAutenticado: _ctx.stateAgenda.codigoUsuarioAutenticado,
                                                      apresentarEmpresa: (_ctx.stateAgenda.acessoVariasEmpresas && _ctx.telaBase.empresasSelecionadas.length > 1)
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("a", {
                                                          onClick: ($event: any) => (_ctx.editarAgendamento(item.codigo)),
                                                          class: "ant-badge ant-badge-status ant-badge-not-a-wrapper"
                                                        }, [
                                                          _createElementVNode("span", {
                                                            style: _normalizeStyle('background-color:' + item.cor),
                                                            class: "ant-badge-status-dot"
                                                          }, null, 4),
                                                          _createElementVNode("span", _hoisted_60, _toDisplayString(item.titulo), 1)
                                                        ], 8, _hoisted_59)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["agendamento", "codigoUsuarioAutenticado", "apresentarEmpresa"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ], 8, _hoisted_57))
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_agendamento_modal, {
      visivel: _ctx.stateAgenda.exibirModal,
      "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.stateAgenda.exibirModal) = $event)),
      operacao: _ctx.stateAgenda.operacao,
      "onUpdate:operacao": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.stateAgenda.operacao) = $event)),
      onSincronizarAgendamento: _ctx.sincronizarAgendamento,
      onLimparVisualizacao: _ctx.limparVisualizacao
    }, null, 8, ["visivel", "operacao", "onSincronizarAgendamento", "onLimparVisualizacao"])
  ]))
}